import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';
import momentTz from 'moment-timezone';

@Pipe({ name: 'sunrise' })
export class SunrisePipe implements PipeTransform {
  transform(time: string, date, timeZone: string = ''): string {
    // Try and parse the passed value.
    if (!time) {
      return '';
    }
    moment.locale(localStorage.getItem('language'));
    const momentDtg = moment(moment(date).format('YYYY-MM-DD ') + time + 'Z');

    // If moment didn't understand the value, return it unformatted.
    if (!momentDtg.isValid()) {
      return time;
    }

    // TimeZone?
    if (timeZone) {
      return momentTz(momentDtg).tz(timeZone).format('HH:mm');
    }

    // Otherwise, return the date formatted as requested.
    return momentDtg.format('HH:mm');
  }
}
